import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'lp-no-data-found',
  templateUrl: './no-data-found.component.html',
  styleUrls: ['./no-data-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoDataFoundComponent {
  @Input() title?: string;
  @Input() hideIcon = false;
  @Input() hideSubtitle = false;
}
